import React from 'react';
import CutePlayer from '../components/CutePlayer';
import WidgetPlayer from '../components/WidgetPlayer';

const StreamPage = ({ title, streamUrl, logoUrl, type = "cute" }) => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center py-24 px-6">
      <div className="mb-16 text-center">
        <h1 className="text-[10px] font-black text-[#00AEEF] uppercase tracking-[0.5em] mb-4">
          {title}
        </h1>
        <div className="h-1 w-16 bg-[#00AEEF] mx-auto rounded-full"></div>
      </div>
      
      <div className="w-full flex justify-center">
        {type === "cute" ? (
          <CutePlayer streamUrl={streamUrl} logoUrl={logoUrl} />
        ) : (
          <WidgetPlayer streamUrl={streamUrl} logoUrl={logoUrl} />
        )}
      </div>
      
      <div className="mt-20 text-center opacity-40">
        <p className="text-[9px] font-black text-gray-500 uppercase tracking-[0.4em]">
          &copy; {new Date().getFullYear()} Console Radio Digital • High Definition Broadcast
        </p>
      </div>
    </div>
  );
};

export default StreamPage;